module.exports = __webpack_public_path__ + "img/pattern1 blue copy 5.0e89fdb8.svg";